<script>
    import {createEventDispatcher} from "svelte";
    import PrimaryButton from "../components/PrimaryButton.svelte";
    import SecondaryButton from "../components/SecondaryButton.svelte";
    import MaterialSlot from "./MaterialSlot.svelte";
    import DangerousButton from "../components/DangerousButton.svelte";

    export let shadersMap;

    const dispatch = createEventDispatcher();

    export let material = {};

    const id = () => `_${Math.random().toString(36).substring(2, 9)}`;

    let modifiedMaterial = {Textures: []};
    let isNew;

    $: modifiedMaterial = material;
    $: isNew = !material.ID;

    let hovering = false;

    const dropTexture = (data) => {
        const event = data.detail.event;
        const target = data.detail.index;
        const start = parseInt(event.dataTransfer.getData("text/plain"));

        const newTextures = modifiedMaterial.Textures;

        const temp = newTextures[target];
        newTextures[target] = newTextures[start];
        newTextures[start] = temp;

        tryUpdateMaterialName();

        modifiedMaterial.Textures = newTextures;
        hovering = null;
    };

    const removeTexture = (event) => {
        const index = event.detail.index;
        delete modifiedMaterial.Textures[index];

        modifiedMaterial.Textures = modifiedMaterial.Textures;
    };

    function tryUpdateMaterialName() {
        if (!isNew) return;

        let texture = modifiedMaterial.Textures[0];

        if (texture && texture.Name) modifiedMaterial.Name = texture.Name;
    }

    async function uploadTexture(event) {
        const files = event.detail.files;
        const index = event.detail.index;

        if (files.length < 1) return;

        let file = files[0];

        const reader = new FileReader();

        reader.addEventListener("load", function () {
            let result = reader.result;

            modifiedMaterial.Textures[index] = {
                Image: result,
                Name: file.name,
            };

            tryUpdateMaterialName();

            modifiedMaterial.Textures = modifiedMaterial.Textures;
        });

        reader.readAsDataURL(file);
    }

    const submitMaterial = () => {
        dispatch("submit", modifiedMaterial);
    };

    const removeMaterial = () => {
        if (confirm("Are you sure?")) dispatch("remove");
    };

    function handleClose() {
        dispatch("close")
    }

</script>

<form>
    <div class="grid grid-cols-2 gap-6">
        <div class="relative z-0 w-full mb-6 group">
            <label
                class="block mb-2 text-sm font-medium text-gray-900"
            >Material name</label
            >
            <input
                bind:value={modifiedMaterial.Name}
                class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5"
                required
                type="text"
            />
        </div>
        <div class="relative z-0 w-full mb-6 group">
            <label
                class="block mb-2 text-sm font-medium text-gray-900"
            >Shader</label
            >
            <select
                aria-label="Shader"
                bind:value={modifiedMaterial.ShaderName}
                class="form-select appearance-none block w-full px-3 py-1.5 text-base font-normal text-gray-900 bg-white bg-clip-padding bg-no-repeat  border border-solid border-gray-300 rounded-lg transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none"
            >
                {#each Object.keys(shadersMap) as shaderName}
                    <option>{shaderName}</option>
                {/each}
            </select>
        </div>
    </div>
    <div class="mb-6">
        <label
            class="block mb-2 text-sm font-medium text-gray-900"
        >Textures</label
        >
        <div class="flex">
            {#each shadersMap[modifiedMaterial.ShaderName] as slotName, index (index)}
                <MaterialSlot
                    data={modifiedMaterial.Textures[index]}
                    {index}
                    slotName={slotName}
                    on:drop={dropTexture}
                    on:remove={removeTexture}
                    on:upload={uploadTexture}
                />
            {/each}
        </div>
    </div>

    <div>
        {#if !isNew}<DangerousButton on:click={removeMaterial}>Remove</DangerousButton><br/>{/if}
        <PrimaryButton on:click={submitMaterial}>Submit</PrimaryButton>
        <SecondaryButton on:click={handleClose}>Cancel</SecondaryButton>
    </div>
</form>
